module.exports = __webpack_public_path__ + "img/terroir-choppy-2.d13a5412.jpg";